module.exports = __webpack_public_path__ + "static/bdm-0939b552068ae20f15d335542e67260c.jpg";